'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

module.exports = function (_React$Component) {
  _inherits(HeaderText, _React$Component);

  function HeaderText(props) {
    _classCallCheck(this, HeaderText);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(HeaderText).call(this, props));

    _this.name = 'HeaderText';
    return _this;
  }

  _createClass(HeaderText, [{
    key: 'getParentStyle',
    value: function getParentStyle(colors) {
      return this.props.isComponentOutlined(this.props, this.name) ? this.props.outlineStyle : void 0;
    }
  }, {
    key: 'getParagraphStyle',
    value: function getParagraphStyle(colors) {
      return { color: colors[this.name] };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var parentStyle = this.getParentStyle(this.props.colors);
      var paragraphStyle = this.getParagraphStyle(this.props.colors);
      return _jsx('div', {
        style: parentStyle,
        onClick: function onClick(event) {
          return _this2.props.handleClick(event, _this2.name);
        }
      }, void 0, _jsx('p', {
        style: paragraphStyle
      }, void 0, 'Welcome to the demo.'), _jsx('p', {
        style: paragraphStyle
      }, void 0, 'You can change the color of this text by picking a color on the right.'));
    }
  }]);

  return HeaderText;
}(_react2['default'].Component);


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/api/white-labeling/header-text.jsx
 ** module id = 873
 ** module chunks = 0
 **/